import { TestimonialMultipleColumnProps } from '@zapier/design-system';
import { COLOR_KEYS } from '../../../constants';

export const DEFAULT_VALUES: TestimonialMultipleColumnProps = {
  numberOfColumns: 2,
  testimonials: new Array(3).fill({
    quote: 'This is a default quote (Edit me)',
    author: 'Name Surname',
    company: 'Zapier',
    hasAuthorAvatar: true,
    avatarUrl: 'https://cdn.zappy.app/5451454a0209e3d746a5f7c2f1a34aff.png',
  }),
  backgroundColor: COLOR_KEYS.cream,
};
